import { DEFAULT_DELAY } from '@/features/email-flows/emails/constants/emailEditor.constants';

/**
 * Default schedule configuration
 */
export const DEFAULT_SCHEDULE = {
    DAYS_AHEAD: 2,
    HOURS_AHEAD: 1,
} as const;

/**
 * Broadcast delay (always 0 for broadcasts)
 */
export const BROADCAST_DELAY = {
    SECONDS: DEFAULT_DELAY.SECONDS,
    UNIT: 'seconds' as const,
} as const;

/**
 * Schedule validation
 */
export const SCHEDULE_VALIDATION = {
    MIN_MINUTES_AHEAD: 10,
    MIN_MILLISECONDS_AHEAD: 10 * 60 * 1000,
} as const;

/**
 * Broadcast flow configuration
 */
export const BROADCAST_FLOW_CONFIG = {
    TYPE: 'user-triggered' as const,
    TRIGGER: 'time' as const,
    NAME: 'Broadcast' as const,
} as const;

/**
 * Broadcast action constants
 * Centralized action identifiers to prevent magic strings
 */
export const BROADCAST_ACTIONS = {
    EDIT: 'edit',
    DELETE: 'delete',
    DUPLICATE: 'duplicate',
    VIEW_RECIPIENTS: 'view-recipients',
} as const;

export type BroadcastAction = (typeof BROADCAST_ACTIONS)[keyof typeof BROADCAST_ACTIONS];

export { BROADCAST_GRID_COLUMNS, BROADCAST_HEADER_COLUMNS, getGridTemplate } from './gridColumns';
